import React from "react";
import PropTypes from "prop-types";

export function OnboardingLayout({ children, steps }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        maxHeight: "100vh",
        overflowY: "auto",
        padding: "30px",
      }}
    >
      <img
        alt="Hubly"
        src="/images/hubly.png"
        style={{
          margin: "auto",
          display: "block",
          width: "149px",
        }}
      />

      <div
        style={{
          maxWidth: "505px",
          width: "100%",
        }}
      >
        {steps}
      </div>
      {children}
    </div>
  );
}
OnboardingLayout.propTypes = {
  children: PropTypes.node,
  steps: PropTypes.node.isRequired,
};

OnboardingLayout.defaultProps = {
  children: null,
};

export default OnboardingLayout;
